<template>
	<div class="technology-page">
		<Head position="absolute" mode="white" :isHaveBack="true" @back="backHead"></Head>
		<!-- 横幅 -->
		<div class="banner">
			<div class="content w1360 animate__animated animate__fadeInUp">
				<div class="heading">绿色碳路 赋能未来</div>
				<div class="des">聚焦低碳创新 解读绿色发展新机遇 每一份碳资讯 都是地球的 “减碳” 力量</div>
			</div>
		</div>
		<div class="main w1360 animate__animated animate__slideInUp">
			<div class="heading">技术文件规范制定与实施</div>
			<div class="list">
				<div class="item" v-for="(item, index) in list" :key="index" @click="jsbzClick(item)">
					<div class="title ellipsis-1">{{ item.groupStandardName }}</div>
					<div class="lines">
						<div class="green"></div>
						<div class="orange"></div>
					</div>
					<div class="des ellipsis-3">
						{{ item.description }}
					</div>
				</div>
			</div>
			<div class="pagination">
				<el-pagination layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page.sync="pageNum" @current-change="getPcrList"></el-pagination>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import { PcrList, DownPrc, LcaCfpPcrManagementDetails } from '@/common/api.js';
import Head from '@/layout/Head/Head.vue';
import Foot from '@/layout/Foot/Foot.vue';
export default {
	name: 'technology',
	components: { Head, Foot },
	data() {
		return {
			// 页码
			pageNum: 1,
			// 每页数量
			pageSize: 6,
			// 总数
			total: 0,
			// pcr列表
			list: [],
		};
	},
	created() {
		this.getPcrList();
	},
	mounted() {},
	methods: {
		backHead() {
			this.$router.push({ name: 'home' });
		},
		// 打开技术标准链接
		jsbzClick(item) {
			if (item.groupStandard){
				window.open(item.groupStandard, '_blank');
			} else {
				let certificationOssPath = item.certificationOssPath ? JSON.parse(item.certificationOssPath) : [];
				if (certificationOssPath && certificationOssPath.length && certificationOssPath[0].url) {
					this.previewPdfAsBlob(certificationOssPath[0].url)
				} else {
					return
				}
			}
		},
		// 获取PDF为Blob，然后创建Object URL
		async previewPdfAsBlob(pdfUrl) {
		
			try {
				// 使用fetch获取
				const response = await fetch(pdfUrl, {
				headers: {
					'Accept': 'application/pdf'
				}
				})
				
				if (response.ok) {
				const blob = await response.blob()
				
				// 创建Object URL
				const blobUrl = URL.createObjectURL(blob)
				
				// 方法1: 使用iframe
				// const iframe = document.createElement('iframe')
				// iframe.src = blobUrl
				// iframe.width = '100%'
				// iframe.height = '600px'
				// document.getElementById('preview-container').appendChild(iframe)
				
				// 方法2: 使用window.open
				window.open(blobUrl, '_blank')
				
				// 清理（在组件销毁时）
				// URL.revokeObjectURL(blobUrl)
				}
			} catch (error) {
				console.error('加载失败:', error)
			}
		},
		async downLoadfile(id, type) {
			console.log(id);
			if (!this.checkUser()) {
				return this.toast('请先登录后下载');
			}
			const res = await LcaCfpPcrManagementDetails({ id });
			if (res.success) {
				const obj = JSON.parse(res.data[type]);
				if (obj) {
					console.log('obj: ', obj);
					let url;
					const filename = obj[0].name;
					if (obj[0].url.indexOf('https') != -1) {
						const top = obj[0].url.split('//')[1];
						const id = top.slice(top.indexOf('/') + 1);
						this.downFile(id, filename);
					} else {
						url = obj[0].url;
						const x = new XMLHttpRequest();
						x.open('GET', url, true);
						x.responseType = 'blob';
						x.onload = (e) => {
							const url = window.URL.createObjectURL(x.response);
							const a = document.createElement('a');
							a.href = url;
							a.download = filename;
							a.click();
						};
						x.send();
					}
				} else {
					Message.error('无文件');
				}
			}
		},
		async downFile(id, name) {
			const res = await DownPrc({ id });
			// 获取文件流数据
			const blob = new Blob([res]);
			// 创建a标签进行下载
			const link = document.createElement('a');
			link.href = URL.createObjectURL(blob);
			const [filename = '', type = ''] = name.split('.');
			link.download = `${filename}(${this.$moment().format('YYYY-MM-DD_HH_mm')}).${type}`;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
		// 显示文件
		showFile(fileUrl) {
			if (!this.checkUser()) {
				return this.toast('请先登录后下载');
			} else {
				this.toast({
					type: 'warning',
					message: '暂未上传'
				});
				return;
				window.open(fileUrl);
			}
		},
		//获取pcr列表
		getPcrList() {
			let data = {
				pageNum: this.pageNum,
				pageSize: this.pageSize,
				keyWord: '',
				startTime: '',
				endTime: '',
				type: ''
			};
			PcrList(data).then((res) => {
				// this.list = [...res.data,...res.data,...res.data,...res.data,...res.data,...res.data,...res.data,...res.data,...res.data,];
				this.list = res.data;
				this.total = res.total;
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.technology-page {
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	position: relative;
	.banner {
		// margin-top: -$head-height;
		background-image: url('~@/assets/tmp/035.png');
		background-size: cover;
		height: 334px;
		.content {
			display: flex;
			flex-direction: column;
			padding-left: 50px;
			box-sizing: border-box;
			.heading {
				margin-top: 122px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 36px;
				color: #ffffff;
				line-height: 52px;
			}
			.des {
				margin-top: 33px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 18px;
				color: #ffffff;
				line-height: 22px;
			}
		}
	}
	.main {
		display: flex;
		flex-direction: column;
		padding-top: 33px;
		min-height: calc(100vh - 334px);
		box-sizing: border-box;
		// padding-bottom: 138px;
		.heading {
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 28px;
			color: #000000;
			line-height: 52px;
		}
		.list {
			margin-top: 4px;
			display: flex;
			flex-wrap: wrap;
			.item {
				width: 410px;
				height: 166px;
				background: #ffffff;
				box-shadow: 0px 2px 15px 0px rgba(203, 214, 252, 0.43);
				padding-top: 21px;
				padding-left: 27px;
				padding-right: 27px;
				padding-bottom: 21px;
				box-sizing: border-box;
				display: flex;
				flex-direction: column;
				margin-top: 30px;
				margin-left: calc((100% - (410px * 3)) / 2);
				cursor: pointer;
				transition: all 0.3s ease;
				&:hover {
					background: $primary;
					.title {
						color: #FFFFFF;
					}
					.lines {
						.green {
							width: 104px;
							background: #FFFFFF;
						}
						.orange {
							width: 58px;
						}
					}
					.des {
						color: #FFFFFF;
					}
				}
				&:nth-child(3n + 1) {
					margin-left: 0;
				}
				.title {
					transition: inherit;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 18px;
					color: #000000;
					line-height: 25px;
				}
				.lines {
					margin-top: 17px;
					display: flex;
					.green {
						width: 27px;
						height: 3px;
						background: $primary;
						transition: all 0.3s ease;
					}
					.orange {
						width: 15px;
						height: 3px;
						background: #ffaeae;
						transition: all 0.3s ease;
					}
				}
				.des {
					transition: inherit;
					margin-top: 13px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 12px;
					color: rgba(#232536, 0.6);
					line-height: 22px;
					text-align: justify;
				}
			}
		}
		.pagination {
			margin-top: auto;
			display: flex;
			justify-content: center;
			align-items: center;
			height: 100px;
		}
	}
}
</style>
